import "./registerErrorHandlers";

import React from "react";
import ReactDOM from "react-dom/client";

import "./i18n";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { Provider } from "react-redux";
import { configureStore } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { pushService } from "./services/pushService";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <ErrorBoundary>
    <Provider store={configureStore({})}>
      <BrowserRouter
        basename={process.env.PUBLIC_URL}
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>
);

// SW enregistré uniquement pour recevoir les Web Push (WhatsApp-style, quand la
// PWA est fermée). Pas de caching offline — le SW n'intercepte aucun fetch.
pushService.registerSW();
